import * as Service from '@/App/Service';
import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';

/**
 * Refresh all critical app data. Called on mount and when the app
 * is activated (foregrounded) after being paused.
 *
 * @return Promise<void>
 */
export async function refreshAllData(): Promise<void> {
	// Refresh the authenticated user from the API
	Store.dispatch('authentication/refreshUser');

	// Fetch remote app configuration (feature flags, settings, etc.)
	Service.App.fetchConfig();

	// Log for visibility
	ChalkySticks.Utility.Log.debug('app', 'App activated: refreshing all data...');
}
